import React, { useEffect } from "react";
// ANT DESIGN COMPONENTS
import { Modal, Spin } from "antd";
// REDUX
import { useDispatch, useSelector } from "react-redux";
import { useDeleteAdapterMutation } from "../../../redux/adapters/adapterAPI";
// AUTHORIZATION
import GETJwtToken from "../../../redux/authentication/authentication";
import { updateOpenModalDeleteAdapter } from "../../../redux/adapters/adapterSlice";
// COMPONENTS
import ModalDeleteItemContainer from "../../components/modal/ModalDeleteItemContainer";
import GlobalAlert2 from "../../home/GlobalAlert2";
// INTERFACES
import { RootState } from "../../../app/store";

function AdaptersDeleteModal() {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const dispatch = useDispatch();

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */
	const { adapter, openModalDeleteAdapter } = useSelector((state: RootState) => state.adapter);

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */
	const [triggerDeleteAdapter, { isLoading, isSuccess, isError, error, reset: resetDeleteAdapter }] =
		useDeleteAdapterMutation();

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const onClickClose = () => {
		dispatch(updateOpenModalDeleteAdapter(false));
	};

	const onClickDelete = async () => {
		const token = await GETJwtToken();
		triggerDeleteAdapter({ id: adapter.id, token });
	};

	// ************************************************* */
	// USE EFFECT ************************************** */
	useEffect(() => {
		if (openModalDeleteAdapter) {
			resetDeleteAdapter();
		}
	}, [openModalDeleteAdapter]);

	useEffect(() => {
		dispatch(updateOpenModalDeleteAdapter(false));
	}, [isSuccess, isError]);
	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<Modal onOk={onClickClose} closable={false} onCancel={onClickClose} open={openModalDeleteAdapter} footer={null}>
			<Spin spinning={isLoading}>
				<ModalDeleteItemContainer name={adapter.name} onClickDelete={onClickDelete} onClickClose={onClickClose} />
			</Spin>
			{/** ---------------------------------------------------- */}
			{/** GLOBAL ALERT */}
			<GlobalAlert2 isError={isError} isSuccess={isSuccess} requestType='DELETE' error={error} name='Adapter' />
		</Modal>
	);
}

export default AdaptersDeleteModal;
